const convert = require('heic-convert');
const { promisify } = require('util');
const fs = require('fs');

async function heicToJpg(file) {
    console.log(file);
    console.log("BLOB? : " + file instanceof Blob);
    const inputBuffer = await promisify(fs.readFile)(file);
    const outputBuffer = convert({
        buffer: inputBuffer, // the HEIC file buffer
        format: 'JPEG', // output format
        quality: 1,
    });
    return promisify(fs.writeFile)('./result', outputBuffer);
};

export default heicToJpg;
